module.exports = __webpack_public_path__ + "img/statistics-icon3.a39a0f76.png";